import * as React from 'react';
import type { Components } from '@mui/material/styles';
import { CaretLeft as CaretLeftIcon } from '@phosphor-icons/react/dist/ssr/CaretLeft';
import { CaretRight as CaretRightIcon } from '@phosphor-icons/react/dist/ssr/CaretRight';

import type { Theme } from '../types';

function PreviousButtonIcon(): JSX.Element {
  return <CaretLeftIcon fontSize="var(--fontSize-md)" />;
}

function NextButtonIcon(): JSX.Element {
  return <CaretRightIcon fontSize="var(--fontSize-md)" />;
}

export const MuiTablePagination = {
  defaultProps: {
    slotProps: {
      actions: {
        nextButtonIcon: { component: NextButtonIcon },
        previousButtonIcon: { component: PreviousButtonIcon },
      },
      select: { size: 'small', variant: 'outlined' },
    },
  },
  styleOverrides: {
    toolbar: { minHeight: '40px', paddingInline: '8px' },
    actions: { marginLeft: '8px' },
    input: { marginRight: '8px', padding: 0 },
    selectLabel: { marginBottom: 0 },
    displayedRows: { marginBottom: 0 },
  },
} satisfies Components<Theme>['MuiTablePagination'];
